import { notification } from 'antd'
import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IDeleteGroupPayload } from '@app-store/slices/group/delete'

interface TaskAction extends Action {
    payload: IDeleteGroupPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.group.delete

function* deleteGroupSagaTask({ payload }) {
    try {
        const response = yield axios.delete(`/companies/group/${payload.groupId}`)
        if (response.success) {
            yield put(onSuccess(response.result))
            notification.success({
                message: 'Group deleted successfully.'
            })
            if (payload.sagaCB) {
                yield payload.sagaCB?.onSuccess()
            }
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* deleteGroupSaga(): any {
    yield takeLatest<TaskAction>(onRequest, deleteGroupSagaTask)
}

export default deleteGroupSaga
